var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "app" },
    [
      _c("AppHeader", { attrs: { fixed: "" } }, [
        _c(
          "div",
          { staticClass: "container" },
          [
            _c(
              "a",
              { staticClass: "navbar-brand", attrs: { href: _vm.site_url } },
              [
                _c("img", {
                  attrs: {
                    src: "/img/brand/logo-big.png",
                    width: "120",
                    height: "35",
                    alt: "",
                  },
                }),
              ]
            ),
            _vm._v(" "),
            _c(
              "b-navbar-nav",
              { staticClass: "ml-auto" },
              [
                _c("DefaultHeaderLanguage"),
                _vm._v(" "),
                _c("b-nav-item", { attrs: { href: "/login" } }, [
                  _vm._v(_vm._s(_vm.$t("common.login"))),
                ]),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "app-body" }, [
        _c("main", { staticClass: "main" }, [
          _c("div", { staticClass: "main-container" }, [_c("router-view")], 1),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }